import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import OrdersColumn from "../../shared/component/dataTable/columns/OrdersColumn.json";
import OrdersMobileColumn from "../../shared/component/dataTable/columns/OrdersMobileColumn.json";
import ReactCountdownClock from "react-countdown-clock";
import Dialog from "../../shared/component/dialog/Dialog";
import OrdersDetail from "./OrdersDetail";
import actionRequiredSound from './actionRequired.wav'
import GeneralUtils from "../../shared/utils/GeneralUtils";
import OrderService from "../../shared/service/OrderService";
import DataTableAll from "../../shared/component/dataTable/DataTableAll";
import '../../shared/styles/SettingsPage.css';

export default class Orders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            seconds: 10,
            maxOrderDateLong: null,
            orderList: []
        };
        this.orderService = new OrderService();
    }

    componentDidMount() {
        this.getNewOrders();
    }

    getNewOrders() {

        let scope = null;
        if (localStorage.getItem("scope") && !GeneralUtils.isNullOrEmpty(localStorage.getItem("scope"))) {
            scope = localStorage.getItem("scope");
        }
        this.orderService.getOpenOrders(scope).then(response => this.setState({
            orderList: response
        }));

        const dataList = this.state.orderList || [];
        for (var i = 0; i < dataList.length; i++) {
            if (dataList[i].read == false) {
                let audio = new Audio(actionRequiredSound);
                audio.play();
                break;
            }
        }
        this.setState({
            seconds: this.state.seconds + 0.00000001
        });
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        {this.newOrderList()}
                    </div>
                </AvForm>
            </div>
        );
    }

    countDownClock = () => {
        this.getNewOrders();
    }

    newOrderList() {

        return (
            <>
                <div className="settings-page__header settings-page__header--with-meta">
                    <h1 className="settings-page__title">Open Orders</h1>
                    <div className="settings-page__countdown">
                        <ReactCountdownClock seconds={this.state.seconds}
                                             color="#1a1a1a"
                                             showMilliseconds={false}
                                             alpha={0.9}
                                             size={50}
                                             onComplete={this.countDownClock}/>
                    </div>
                </div>
                <div className="settings-page__panel">
                    <div className="settings-page__table-wrap">
                            <DataTableAll fields={GeneralUtils.isMobile() ? OrdersMobileColumn.fields : OrdersColumn.fields}
                                          objectName={GeneralUtils.isMobile() ? OrdersMobileColumn.name : OrdersColumn.name}
                                          data={this.state.orderList}
                                          paginator={true}
                                          responsive={false}
                                          rows={10}
                                          emptyMessage="Not any order"
                                          selectionMode="single" onDataSelect={this.onDataSelect}
                                          loading={this.state.loading}/>
                    </div>

                    <Dialog visible={this.state.displayDialog}
                            className="order-merchant-detail-dialog"
                            header={this.state.orderNo == null ? "Order Details" : this.state.orderNo}
                            onHide={() => this.setState({displayDialog: false})}
                            style={GeneralUtils.getDialogStyleForOrderDetailDialog()}>

                        <OrdersDetail refreshDataTable={this.refreshDataTable} ref={(elem) => this.refModelSave = elem}
                                      closeDisplayDialog={this.refreshDataTable}/>
                    </Dialog>
                </div>
            </>
        );
    };

    refreshDataTable = () => {
        this.closeDisplayDialog();
        this.getNewOrders();
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false, orderNo: null});
    }

    onDataSelect = (data) => {
        GeneralUtils.openDialogThenRef(this, {
            orderNo: data.orderNo,
            displayDialog: true
        }, () => this.refModelSave, (ref) => ref.setData(Object.assign({}, data)));
    }


}
